// extracted by mini-css-extract-plugin
module.exports = {"nav":"FooterNav_nav_3xDKo"};